import { gql } from 'react-apollo';

export const churchGroupsBasicData = gql`
  fragment withGroupsBasicData on ChurchGroup {
    id
    name
  }
`;

export const revivalBasicInfo = gql`
  fragment revivalBasicInfo on RevivalInfo {
    id
    title
    phase
    phaseDayNumber: phase_day_number
    phaseWeekNumber: phase_week_number
  }
`;

export const revivalFullInfo = gql`
  fragment revivalFullInfo on Revival {
    id
    title
    image {
      default
    }
    phase
    phaseDayNumber: phase_day_number
    preparationStartDate: preparation_start_date
    startDate: start_date
    endDate: end_date
    preparationDaysCount: preparation_days_count
    revivalDaysCount: revival_days_count
  }
`;

export const basic  = gql`
  fragment basicChurchFields on Church {
    id
    name
    code
    timezone
    revival {
      id
      phase
      title
      image {
        default
      }
      phaseDayNumber: phase_day_number
      preparationStartDate: preparation_start_date
      startDate: start_date
      endDate: end_date
    }
  }
`;

export const full = gql`
  fragment allChurchFields on Church {
    ...basicChurchFields
    addressLine1: address_line_1
    addressLine2: address_line_2
    notes
    size
    contactPerson: contact_person
    revival {
      ...revivalFullInfo
    }
    evangelist {
      id
      name
      email
      phone
    }
  }

  ${basic}
  ${revivalFullInfo}
`;



// WEBPACK FOOTER //
// ./src/graphql/fragments/church.js